<template lang="html">
<div class="main">
  <div class="phone">
    <div v-if="system === 'android'">
      <div class="wechat" v-if='wechat'>
        {{message.Pl152}}
      </div>
      <div class="logo">
        <img src="../../assets/images/app-logo.png" alt="">
      </div>
      <div class="button blue" v-if='!wechat' @click="download()">
        {{message.Al160}}
      </div>
      <div @click="downloadApp()" class="button" v-if='!wechat'>
        {{message.Al161}}
      </div>
    </div>
    <!-- <div v-if="system ==='ios'">
      <div class="logo">
        <img src="../../assets/images/app-logo.png" alt="">
      </div>
      <div class="wechat">
        {{message.Pl153}}
      </div>
    </div> -->
  </div>
</div>
</template>

<script>
export default {
  data () {
    if (
      this._global.config.browser === 'wechat' ||
      this._global.config.browser === 'qq'
    ) {
      var wechat = true
    } else {
      wechat = false
    }
    if (this._global.config.system === 'ios') {
      var system = 'ios'
    } else {
      system = 'android'
    }
    return {
      message: {
        Pl152: this.$lang.ui.prompt.l152,
        Pl153: this.$lang.ui.prompt.l153,
        Al160: this.$lang.ui.app.l160,
        Al161: this.$lang.ui.app.l161
      },
      system: system,
      wechat: wechat,
      downloadUrl: ''
    }
  },
  mounted () {
    this.openApp()
    // this.setCode()
    this.getDownloadUrl()
  },
  methods: {
    openApp () {
      const token = this.$route.query.token
      const type = this.$route.query.type
      const host = window.location.origin
      location.href = 'caton://cydex/enterprise?token=' + token + '&type=' + type + '&host=' + host
    },
    // setCode () {
    //   var code = this._global.conditionCode(localStorage.getItem('ip'))
    //   var data = {
    //     id_code: code,
    //     user_info: {
    //       email: this.$route.query.email
    //     }
    //   }
    //   this.$api.setCode(data)
    // },
    getDownloadUrl () {
      this.$api.getDownloadUrl(response => {
        if (this.system === 'ios') {
          this.downloadUrl = response.ios
        } else {
          this.downloadUrl = response.android
        }
      })
    },
    downloadApp () {
      window.open(this.downloadUrl)
    }
  }
}
</script>

<style lang="css" scoped>
.main {
  position: relative;
  width: 100%;
  height: 100%;
}
.logo {
  width: 80px;
  height: 80px;
  margin: 0 auto;
  margin-bottom: 60px;
}
.wechat {
  width: 100%;
  padding: 0 10px 50px 10px;
  font-size: 16px;
  text-align: center;
}
.logo img {
  display: block;
  width: 96px;
  margin: 0 auto;
  margin-bottom: 15px;
}
.phone {
  position: absolute;
  overflow: hidden;
  width: 100%;
  margin-top: 30%;
}
.button {
  font-size: 16px;
  text-align: center;
  width: 70%;
  padding: 8px 0;
  cursor: pointer;
  border: 1px solid #007bc5;
  border-radius: 4px;
  max-width: 240px;
  margin: 0 auto;
  margin-bottom: 20px;
}
.button.blue {
  background-color: #007bc5;
  color: #fff;
}
</style>
